export enum OrderModuleEvents {
    SET_PAYMENT_METHOD = 'order/SET_PAYMENT_METHOD',

}